import angular from 'angular';

angular.module('cloudX').directive('cxPriceGridSelect', [
  function() {
    return {
      restrict: 'E',
      template:
        '<a href="#" editable-select="value" onbeforesave="save({newValue:$data})" e-ng-options="item.id as item.name for item in grids" edit-disabled="disabled">' +
        '<span ng-show="value">{{getDisplayValue()}}</span><i class="glyphicon glyphicon-pencil" ng-show="!value"></i>' +
        '</a>',
      scope: {
        value: '=data',
        save: '&',
        disabled: '=',
      },
      controller: [
        '$scope',
        '$http',
        'appUrls',
        '$translate',
        function($scope, $http, appUrls, $translate) {
          $scope.grids = [];
          $http.get(appUrls.api + '/api/price/Grid').then(function({ data }) {
            $scope.grids = data.map(x => ({
              ...x,
              name: x.name === 'Default' ? $translate.instant('Default') : x.name,
            }));
            if ($scope.value) {
              const grid = data.find(x => x.id === $scope.value);
              $scope.displayValue = grid ? grid.name : null;
            }
            return data;
          });
          $scope.getDisplayValue = () => {
            if (!$scope.value || !$scope.grids) return null;
            const grid = $scope.grids.find(x => x.id === $scope.value);
            return grid ? grid.name : null;
          };
        },
      ],
    };
  },
]);
